export const teams_list = [
  {
    name: 'Norway',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/NOR',
    fifa_ranking: 12,
    eliminated: true,
  },
  {
    name: 'Japan',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/JPN',
    fifa_ranking: 11,
    eliminated: true,
  },
  {
    name: 'England',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/ENG',
    fifa_ranking: 4,
    eliminated: false,
  },
  {
    name: 'Switzerland',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/SUI',
    fifa_ranking: 20,
    eliminated: true,
  },
  {
    name: 'Netherlands',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/NED',
    fifa_ranking: 9,
    eliminated: true,
  },
  {
    name: 'Australia',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/AUS',
    fifa_ranking: 10,
    eliminated: true,
  },
  {
    name: 'Jamaica',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/JAM',
    fifa_ranking: 43,
    eliminated: true,
  },
  {
    name: 'South Africa',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/RSA',
    fifa_ranking: 54,
    eliminated: true,
  },
  {
    name: 'Nigeria',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/NGA',
    fifa_ranking: 40,
    eliminated: true,
  },
  {
    name: 'Colombia',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/COL',
    fifa_ranking: 25,
    eliminated: true,
  },
  {
    name: 'Spain',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/ESP',
    fifa_ranking: 6,
    eliminated: false,
  },
  {
    name: 'Denmark',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/DEN',
    fifa_ranking: 13,
    eliminated: true,
  },
  {
    name: 'Morocco',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/MAR',
    fifa_ranking: 72,
    eliminated: true,
  },
  {
    name: 'France',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/FRA',
    fifa_ranking: 5,
    eliminated: true,
  },
  {
    name: 'USA',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/USA',
    fifa_ranking: 1,
    eliminated: true,
  },
  {
    name: 'Sweden',
    flag_url: 'https://api.fifa.com/api/v3/picture/flags-sq-4/SWE',
    fifa_ranking: 3,
    eliminated: true,
  },
];
